import React, { useEffect, useState } from "react";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";
import CompanyTable from "./company-table/CompanyTable";
import { Pagination } from "antd";

const Companies = ({ data, handleDelete, getCompanys, onChangeVal, initialVlue, handleChange, reset }) => {
  // const [count, setCount] = useState([])
  // useEffect(() => {
  //   if (data?.totalPages) {
  //     const arrr = []
  //     for (let i = 0; i < data.totalPages; i++) {
  //       arrr.push(i + 1)
  //     }
  //     setCount(arrr);
  //   }
  // }, [data])
  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>Company</h5>
          </div>
          <div className="addNew">
            <Link to="/admin/create-company" className="btn btn-success">
              <AiOutlinePlus /> Add New Company
            </Link>
          </div>
        </div>

        <div className="pageBody">
          <CompanyTable data={data} handleDelete={handleDelete} initialVlue={initialVlue} handleChange={handleChange} getCompanys={getCompanys} reset={reset} />
        </div>

        <div className="pageFooter mt-2">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>Showing {data?.totalCount} entries</p>
              </div>
            </div>
            <div className="col-md-6">
              <Pagination
                defaultCurrent={1}
                onChange={onChangeVal}
                total={data?.totalCount}
              />
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Companies;
